export default "__VITE_ASSET__VWBNC_YO__"